// tempa-xlsx/xlsx.js expects cptable as a global; set it before any xlsx import.
import cptable from '../../node_modules/tempa-xlsx/dist/cpexcel.js';

globalThis.cptable = cptable;
